import React from "react";
import { useParams } from "react-router-dom";

import SchemaNav from "features/Schema/SchemaNav";
import PageContent from "ui/PageContent";
import Panel from "ui/Panel";

import IndexTreeMap from "./IndexTreeMap";
import Table from "./Table";
import { useQueryStringSearch } from "ui/QueryStringSearch";

const SchemaIndexList: React.FunctionComponent = () => {
  const { databaseId } = useParams();
  const [searchTerm, SearchInput] = useQueryStringSearch("q");

  return (
    <PageContent
      title="Schema Statistics"
      pageCategory="schema-indices"
      pageName="index"
      featureNav={<SchemaNav databaseId={databaseId} />}
    >
      <Panel title="Largest Indexes By Size">
        <IndexTreeMap databaseId={databaseId} />
      </Panel>
      <Panel title="All Indexes" secondaryTitle={<SearchInput />}>
        <Table databaseId={databaseId} searchTerm={searchTerm} />
      </Panel>
    </PageContent>
  );
};

export default SchemaIndexList;
